module.exports = __webpack_public_path__ + "733b806cd8ed41beb98631148a0bb88c.svg";